import { gql } from '@apollo/client';

export const UPLOAD_LMI_PROOF_DOC = gql`
  mutation Flex_UploadLmiProofDoc($input: LMIProofDocUploadInput!) {
    uploadLMIProofDoc(input: $input) {
      id
    }
  }
`;
